import { render } from "./OrganizationManagement.vue?vue&type=template&id=61039bde&scoped=true"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js"

import "./OrganizationManagement.vue?vue&type=style&index=0&id=61039bde&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61039bde"]])

export default __exports__